import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import StyleInjector from "../../layout/StyleInjector";

class PodcastHostList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view.push("color");
        } else if (props.view instanceof Object) {
            props.view.color = "";
        } else {
            props.view = ["color"];
        }
        return (
            <Fragment>
                {((this.state || {}).rows || []).map((row, idx) => {
                    if (row.color) {
                        let hex = row.color;
                        if (hex.indexOf('#') === 0) {
                            hex = hex.slice(1);
                        }
                        // convert 3-digit hex to 6-digits.
                        if (hex.length === 3) {
                            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                        }
                        if (hex.length !== 6) {
                            return null;
                        }
                        var r = parseInt(hex.slice(0, 2), 16),
                            g = parseInt(hex.slice(2, 4), 16),
                            b = parseInt(hex.slice(4, 6), 16);
                        return <StyleInjector key={idx} style={"td.p-editable-column.p-cell-editing {background-color: rgba(" + r + "," + g + "," + b + ", .1)"/* + "; color: " + invertColor(row.color)*/ + "}"} id={"program-" + row.id} />;
                    }
                    return null;
                })}
                <SelectorGrid
                    ref={(el) => this.list = el}
                    gridid={this.props.gridid !== undefined ? this.props.gridid : "PodcastHostList"}
                    {...props}
                    columns={{
                        "id": {header: 'Kód', width: 1, sortable, filterable},
                        "host_option.optionlabel": {header: 'Szociális média', width: 3, sortable, filterable},
                        "url": {header: 'Url', width: 8, sortable, filterable},
                    }}
                    onLoadCompleted={(response) => {
                        this.setState({rows: response.rows});
                    }}
                    rowClassName={(rowData) => {
                        return {["program-" + rowData.id]: true};
                    }}
                    orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                    selection={selection}
                    onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                />
            </Fragment>
        );
    }
}

export default PodcastHostList;
